// extracted by mini-css-extract-plugin
export var productImage = "_qq-1";
export var viewLink = "_qq-2";
export var wishlistItem = "_qq-0";